import { useMemo } from 'react';
import { ROUTES_V2 } from '../../../../routes';

export const getIndividualMessageUrl = (
  actorAccessToken: string,
  instanceAccessToken: string,
  messageId: string,
  returnTo?: string
) => {
  return ROUTES_V2.messageDetails.url(
    actorAccessToken,
    instanceAccessToken,
    messageId,
    returnTo
  );
};

export const useIndividualMessageUrl = (
  actorAccessToken: string,
  instanceAccessToken: string,
  messageId: string,
  returnTo?: string
) => {
  return useMemo(() => {
    return getIndividualMessageUrl(
      actorAccessToken,
      instanceAccessToken,
      messageId,
      returnTo
    );
  }, [actorAccessToken, instanceAccessToken, messageId, returnTo]);
};

export const getIndividualTaskUrl = (
  actorAccessToken: string,
  instanceAccessToken: string,
  taskId: string,
  returnTo?: string
) => {
  return ROUTES_V2.taskDetails.url(
    actorAccessToken,
    instanceAccessToken,
    taskId,
    returnTo
  );
};

export const useIndividualTaskUrl = (
  actorAccessToken: string,
  instanceAccessToken: string,
  taskId: string,
  returnTo?: string
) => {
  return useMemo(() => {
    return getIndividualTaskUrl(
      actorAccessToken,
      instanceAccessToken,
      taskId,
      returnTo
    );
  }, [actorAccessToken, instanceAccessToken, taskId, returnTo]);
};

export const getIndividualInstanceUrl = (
  actorAccessToken: string,
  instanceAccessToken: string,
  queryParams: {
    w?: number;
    g?: string;
  } = {}
) => {
  return ROUTES_V2.instance.url(
    actorAccessToken,
    instanceAccessToken,
    queryParams
  );
};

export const useIndividualInstanceUrl = (
  actorAccessToken: string,
  instanceAccessToken: string
) => {
  return useMemo(() => {
    return getIndividualInstanceUrl(actorAccessToken, instanceAccessToken);
  }, [actorAccessToken, instanceAccessToken]);
};

export const getDashboardUrl = (
  userAccessToken: string,
  queryParams: {
    returnTo?: string;
  } = {}
) => {
  return ROUTES_V2.dashboard.url(userAccessToken, queryParams);
};

export const getInboxUrl = (
  userAccessToken: string,
  queryParams: {
    g?: string;
    u?: string[] | null;
    t?: string[] | null;
    tsort?: string;
  } = {}
) => {
  return ROUTES_V2.inbox.url(userAccessToken, queryParams);
};

export const getInboxTasksUrl = (
  userAccessToken: string,
  taskTemplateId: string,
  queryParams: {
    returnTo?: string;
    g?: string;
    u?: string[] | null;
    t?: string[] | null;
    i?: string;
    tsort?: string;
  } = {}
) => {
  return ROUTES_V2.inboxTasks.url(userAccessToken, taskTemplateId, queryParams);
};

export const getInboxTaskUrl = (
  userAccessToken: string,
  taskTemplateId: string,
  instanceAccessToken: string,
  queryParams: {
    returnTo?: string;
    g?: string;
    u?: string[] | null;
    t?: string[] | null;
    tsort?: string;
  } = {}
) => {
  return ROUTES_V2.inboxTask.url(
    userAccessToken,
    taskTemplateId,
    instanceAccessToken,
    queryParams
  );
};

export const getInboxMessagesUrl = (
  userAccessToken: string,
  msgTemplateId: string,
  queryParams: {
    returnTo?: string;
    g?: string;
    u?: string[] | null;
    t?: string[] | null;
    i?: string;
    tsort?: string;
  } = {}
) => {
  return ROUTES_V2.inboxMessages.url(
    userAccessToken,
    msgTemplateId,
    queryParams
  );
};

export const getInboxMessageUrl = (
  userAccessToken: string,
  msgTemplateId: string,
  instanceAccessToken: string,
  queryParams: {
    returnTo?: string;
    g?: string;
    u?: string[] | null;
    t?: string[] | null;
    tsort?: string;
  } = {}
) => {
  return ROUTES_V2.inboxMessage.url(
    userAccessToken,
    msgTemplateId,
    instanceAccessToken,
    queryParams
  );
};

export const isImpersonation = () => {
  return !!window?.location.search.includes('impersonate=true');
};

export const getNonImpersonationUrl = () => {
  const u = new URL(window.location.href);
  u.searchParams.delete('impersonate');
  return u.toString();
};
